const STATE_TEXT_MAP = {
  'pending approval': 'pending',
  'not approved': 'rejected',
};

export default {
  props: {
    state: {
      type: String,
      default: 'pending',
    },
    theme: {
      type: String,
      default: '',
    },
  },
  computed: {
    transformedStatus() {
      const statelowerCased = this.state.toLowerCase();
      if (statelowerCased in STATE_TEXT_MAP) {
        return STATE_TEXT_MAP[statelowerCased];
      }
      return statelowerCased;
    },
    classModifiers() {
      return {
        'state-icon': true,
        [`state-icon--${this.transformedStatus}`]: true,
        [`state-icon--${this.theme}`]: this.theme,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/pending-requests/state-icon/state-icon.js